"use client"
import styles from "./ActionLogsModal.module.css"

const ActionLogsModal = ({ shift, onClose }) => {
  console.log("shift>>>", shift);
  const formatTimestamp = (timestamp) => {
    // Handle null or undefined timestamp
    if (!timestamp) return 'N/A';
    
    // Convert timestamp to string safely
    const timestampStr = String(timestamp);
    
    // Check if timestamp is in milliseconds (13 digits) or seconds (10 digits)
    let date;
    if (/^\d{13}$/.test(timestampStr)) {
      date = new Date(parseInt(timestampStr, 10));
    } else if (/^\d{10}$/.test(timestampStr)) {
      // Convert seconds to milliseconds
      date = new Date(parseInt(timestampStr, 10) * 1000);
    } else if (isNaN(Date.parse(timestampStr))) {
      // If it's not a valid date string either
      console.error('Invalid timestamp format:', timestamp);
      return 'N/A';
    } else {
      // If it's already a date string
      date = new Date(timestampStr);
    }
    
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', timestamp);
      return 'N/A';
    }
  
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getLogIcon = (status) => {
    switch (status) {
      case "Approved":
        return "✓"
      // case "RESOLVED":
      //   return "✓"
      case "RESOLVED":
        return "!"
      case "PENDING_APPROVAL":
        return "⏳"
      default:
        return "•"
    }
  }

  const getLogClass = (status) => {
    switch (status) {
      case "Approved":
        return "logSuccess"
      // case "RESOLVED":
      //   return "logSuccess"
      case "RESOLVED":
        return "logWarning"
      case "PENDING_APPROVAL":
        return "logPending"
      default:
        return "logDefault"
    }
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }


  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.logsModal}>
        <div className={styles.modalHeader}>
          <h2>Action Logs</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.logsSection}>
            <h4>Timeline</h4>
            { shift.timeLineStatus === 'RESOLVED' ? (
              <div className={styles.logsTimeline}>
                
                  <div className={`${styles.logEntry} ${styles[getLogClass(shift.timeLineStatus)]}`}>
                    <div className={styles.logIcon}>{getLogIcon(shift.timeLineStatus)}</div>
                    <div className={styles.logContent}>
                      <div className={styles.logAction}>{shift.timeLineStatus === 'DISPUTED' || shift.timeLineStatus === 'RESOLVED'
    ? `Dispute Raised - ${shift?.disputedReason=="Others" ? "Others (" + shift?.disputedComment + ")" : shift?.disputedReason}`
    : null
  }</div>
                      <div className={styles.logTimestamp}>{formatTimestamp(shift.disputeAt)}</div>
                    </div>
                  </div>
              </div>
            ) : null}
              <div className={styles.logsTimeline}>
                {/* {shift?.logs?.map((log, index) => ( */}
                  <div className={`${styles.logEntry} ${styles[getLogClass(shift.status)]}`}>
                    <div className={styles.logIcon}>{getLogIcon(shift.status)}</div>
                    <div className={styles.logContent}>
                      <div className={styles.logAction}>Approved</div>
                      <div className={styles.logTimestamp}>{formatTimestamp(shift.timeLineStatus === 'RESOLVED' ?shift.resolvedAt :shift.approvedAt  )}</div>
                    </div>
                  </div>
                {/* ))} */}
              </div>
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActionLogsModal
